<template>
    <div class="web_index">
       <BaseHeader></BaseHeader>
        <div style="width: 100%;height: 80px">
        </div>

        <div class="column_div">
            <div class="column">
                <div v-for="product in productList" v-bind:class="[id == product.id ? 'column_name_red' : 'column_name']" @click="choose(product.id)">
                    <span style="cursor:pointer;">{{product.title}}
                        <!--{{id}} {{product.id}} {{id==product.id?'T':'F'}}-->
                    </span>
                </div>

            </div>
        </div>

        <div class="web_content">
            <div class="content">
                <div id="one" style="height: 30px;background-color: #F0F4F5;" class="stip"></div>
                <div class="content_type" ref="scrollOne" v-for="product in productList">
                    <div class="content_title">
                        <span style="font-size: 24px;color: #000000">{{product.title}}</span>
                        <span style="font-size: 16px;color: #323232">{{product.titleSecond}}</span>
                        <!--<span style="font-size: 16px;color: #323232">做最好的杂志</span>-->
                    </div>

                    <div v-if="product.titleThird" class="content_two title3list" style="margin-top: 10px">
                        <span class="title3Item" v-for="title3Item in product.titleThird.split('\n')">
                            {{title3Item}}
                        </span>
                        <!--<span>●宁夏日报报业集团主管主办，《看天下》杂志社出版</span>-->
                        <!--<span style="padding-left: 40px;">●海丰传媒代理《看天下》杂志广告与发行业务</span>-->
                    </div>
                    <div class="product_content" v-html="product.content"></div>

                    <div class="content_erweima" v-if="product.isQrCode">


                        <div class="content_erweima_title" >
                            <div class="qr_code_html"  v-html="product.qrCodeContent" >

                            </div>
                            <!--扫描订阅《看天下》杂志：-->
                        </div>
                        <img class="content_erweima_png" :src="product.qrCodeUrl" :style="'width:'+product.qrCodeWidth+'px;height: auto;' ">
                    </div>

                    <div id="two" style="height: 30px;background-color: #F0F4F5;" class="stip"></div>
                </div>





            </div>

        </div>


        <component v-bind:is="'BaseBottom'"></component>
    </div>
</template>

<script>
    import BaseBottom from './BaseBottom.vue'
    import BaseHeader from './BaseHeader.vue'
    import productService from '../../service/ProductService'
    import router from '../../router'

    export default {
        components: {BaseBottom: BaseBottom,BaseHeader},
        name: 'Index',
        data() {
            return {
                id:'',
                productList:[],
                jumpType: 1,
                columnType: 1,
                navShow: ''
            }
        },
        methods: {

            choose(id) {
                let that = this
                that.id = id
                if(this.$route.query.id!=id){
                    router.push({
//                    path: 'join',
                        query:{'id':id}
                    })
                }

                // alert(that.columnType)
                const returnEles=document.querySelectorAll('.stip')
                const returnEle=returnEles[id-1]
                if (!!returnEle) {
                    returnEle.scrollIntoView(true);
                }


            },

            handleScroll() {
                //获取滚动时的高度
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                // alert(scrollTop)

                this.navShow = scrollTop;

                const contentList=document.querySelectorAll('.content_type')

                let allHeight=0;
                if(!contentList[0]){
                    return
                }
//                console.log(scrollTop+'<'+contentList[0].offsetHeight);
                if(scrollTop<contentList[0].offsetHeight){
                    this.id = 1;
                    return;
                }

                for(var i=0;i<contentList.length;i++){

                    let currentHeight=contentList[i].offsetHeight;
                    allHeight=allHeight+currentHeight;
                    if(scrollTop<allHeight){
                        break;
                    }
                    this.id = i+2;
                }
//                console.log(this.id,'<<'+allHeight)


            }

        },
        mounted() {
            // alert(this.$route.query.columnType)
            let that=this
            productService.getListByProduct(this,{},function (resp) {
                that.productList=resp.productList

                if (that.$route.query.id != null) {
                    that.id = that.$route.query.id
                    setTimeout(function () {
                        that.choose(that.id)
                    },0)


                }

            })

            window.addEventListener("scroll", this.handleScroll);

        },
        updated() {
            window.addEventListener("scroll", this.handleScroll);
        }
    }
</script>


<style scoped="page">
    .web_index {
        width: 100%;
        background-color: #F0F4F5;
    }

    .web_title {
        width: 100%;
        height: 80px;
        background-color: #ffffff;
        position: fixed;
        top: 0;
        z-index: 1000;
    }

    .web_title_content {
        width: 1290px;
        height: 80px;
        margin: auto;
        position: relative;
    }

    .title_img {
        margin-left: 40px;
        margin-top: 18px;
    }

    .title_content {
        height: 80px;
        position: absolute;
        right: 45px;
        top: 0;
    }

    .title {
        float: right;
        height: 80px;
        line-height: 80px;
        font-size: 18px;
    }

    .title_red {
        float: right;
        height: 70px;
        line-height: 80px;
        font-size: 18px;
        border-bottom: 2px solid #cd001b;
        color: #000000;
    }

    .column_div {
        width: 1210px;
        height: 540px;
        position: fixed;
        top: 110px;
        left: calc(50% - 605px);
    }

    .column {
        width: 180px;
        /*height: 540px;*/
        background-color: #535353;
    }

    .web_content {
        width: 1210px;
        margin: auto;
    }

    a {
        text-decoration: none
    }

    .column_name {
        height: 54px;
        line-height: 54px;
        font-size: 14px;
        text-align: center;
        color: #ffffff;
    }

    .column_name_red {
        height: 54px;
        line-height: 54px;
        font-size: 14px;
        text-align: center;
        color: #ffffff;
        background-color: #EE534B;
    }

    .content_title {
        margin-left: 30px;
        padding-top: 60px;
    }

    .content_img {
        margin-left: 30px;
        margin-top: 40px;
    }

    .content {
        width: 1010px;
        background-color: #ffffff;
        margin-left: 200px;
    }

    .content_type {
        /*margin-top: 20px;*/
        position: relative;

    }

    /*.content_one {*/
        /*margin-left: 30px;*/
        /*margin-right: 30px;*/
        /*margin-top: 40px;*/
        /*font-size: 16px;*/
        /*color: #323232;*/
    /*}*/

    .content_one,.content_two {
        margin-left: 30px;
        margin-right: 30px;
        margin-top: 30px;
        font-size: 14px;
        color: #323232;
        line-height: 22px !important;
    }

    .content_two img{max-width: 950px;}

    .content_three {
        margin-left: 30px;
        margin-top: 60px;
        margin-bottom: 60px;
        font-size: 14px;
        color: #323232;
    }

    .content_erweima {
        position: absolute;
        right: 30px;
        bottom: 48px;
    }

    .content_erweima_title {
        float: left;
        font-size: 14px;
        color: #323232;
        /*width: 210px;*/
        padding-right: 40px;
        min-height: 80px;

    }
    .qr_code_html{
        display: table-cell;
        vertical-align: middle;
        height: 80px;
    }

    .content_erweima_png {
        float: left;
    }


    .web_bottem {
        background-color: #2E3139;
        width: 100%;
        height: 120px;
        font-size: 16px;
        color: #C4C4C4;
        line-height: 120px;
        text-align: center;
    }

    .title3list .title3Item:first-child{padding-left: 0px;}
    .title3list .title3Item{padding-left: 40px;}

    .product_content{margin-left: 30px;margin-top: 40px; margin-right: 30px;}
    .product_content >>> p{margin: 30px 0;line-height: 22px;color: #323232;font-size: 14px;}
</style>
<style>

</style>



// WEBPACK FOOTER //
// src/components/web/Product.vue